import { createContext } from 'react';
import useTheme from '../../shared/hooks/useTheme';
import type { CommonType } from '../../shared/types/CommonType';
import type { ResolvedTheme } from '../../shared/types/ThemeType';

type Theme = {
  mode: ResolvedTheme
  isAuto: boolean
  setIsAuto: (isAuto: boolean) => void
};

const ThemeContext = createContext<Theme>({
  mode: 'light',
  isAuto: true,
  setIsAuto: () => {},
});

export const ThemeProvider = ({ children }: CommonType) => {
  const [isEnabled, , isAuto, setIsAuto] = useTheme();

  const value: Theme = {
    mode: isEnabled ? 'dark' : 'light',
    isAuto,
    setIsAuto
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};